import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { humanizeTime, i18nIntl } from '../../lib/ep';

import GameContainer from './GameContainer.js';

import CrushCanvas from '../games/CrushCanvas';
import MisconfiguredGameWarning from './MisconfiguredGameWarning.js';
import { clientFinalPage } from '../games/StageFinalMessages.js';

const Instructions = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const stage = props.stage.Stage;
	const game_time = (stage.game_time != undefined) ? stage.game_time : 30;

	const score_ranges = [10, 20, 50];

	return (
		<>
			<div class="instructions_section challenge_definition">
				<strong>{i18n("Your challenge")}</strong>

				<span>
					<FormattedMessage id="{total} combinations" values={{total:stage.crush_min}} /> - {humanizeTime(game_time, i18n)}
				</span>
			</div>

			{(stage.crush_images.length > 0) && (
				<div class="instructions_section elements">
					<strong class="mod_align_center">{i18n("Game items")}</strong>

					<ul class="items_list">
						{score_ranges.map((range, r) => {
							const items_with_score = stage.crush_images.filter((i) => (i.points == range));
							if(items_with_score.length == 0) return null;

							return (
								<React.Fragment key={`range_${r}`}>
									{items_with_score.map((item) => {
										return (
											<li key={`item_${item.id}`} class={`single_item is_${range}_points`}>
												<img src={item.full_image} width="100%" alt={item.name} />

												<strong>+{range}</strong>
											</li>
										)
									})}
								</React.Fragment>
							)
						})}
					</ul>
				</div>
			)}
		</>
	)
};

const Legend = (props) => {
	return (
		<aside class="gui_legend gui_main_text_color_on_bg">
			<span class="tip_label">
				<span class="knk-combo-l gui_small_icon" />

				<span class="knk-combo-t gui_small_icon" />

				<FormattedMessage
					id="points × {mult}"
					values={{ mult:'2' }}
				/>
			</span>
			<span class="tip_label">
				<span class="knk-combo-c gui_small_icon" />

				<FormattedMessage
					id="points × {mult}"
					values={{ mult:'3' }}
				/>
			</span>
		</aside>
	)
};

const CrushClient = ({ stage, ...props }) => {
	const final_stage = clientFinalPage(stage, props.actual_state);

	return (
		<GameContainer
			{...props}
			stage={final_stage}
			instructions={<Instructions
				stage={stage}
				intl={props.intl}
			/>}
			instructions_has_border={false}
			legend={<Legend
				intl={props.intl}
			/>}
			game_type="crush"
			auto_start_timer={false}
			display_audio_controls={true}
		>
			{((stage.Stage?.crush_images ?? []).length > 4) ? (
				<CrushCanvas />
			) : (
				<MisconfiguredGameWarning
					message="Create at least 5 elements to generate the game"
				/>
			)}
		</GameContainer>
	)
};

export default injectIntl(CrushClient);